import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { POSITION_GROUPED } from '@app/config/position.data';
import { profile_access_module } from '@app/config/role-name.enum';
import { path_module_admin, path_module_employer, path_module_public } from '@app/models/routes.name';
import { ConstantsService } from '@app/services/constants.service';
import { EmployerService } from '@app/services/employer.service';
import { JobService } from '@app/services/job.service';
import { PlatformService } from '@app/services/platform.service';
import { UserService } from '@app/services/user.service';
import { status_code } from 'functions/src/help/status-query';
import { first, Subscription } from 'rxjs';

export interface IRouterTranslate {
  route: string,
  adminAccess: boolean
}

@Component({
  selector: 'app-navigation-bar-white',
  templateUrl: './navigation-bar-white.component.html',
  styleUrls: ['./navigation-bar-white.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationBarWhiteComponent implements OnInit, OnDestroy {

  @Input() class: string = 'form-control';

  public profile_access_module = profile_access_module;
  public path_module_employer = path_module_employer;

  public currentTs: number = 0;
  private isTouchScreen = 'ontouchstart' in window;

  public POSITION_GROUPED = POSITION_GROUPED;
  public path_module_public = path_module_public;
  public dummyFilterCount: number = 1;

  public currentUrl: string = '';
  private subscriptionRouter: Subscription;
  private subscriptionLoginBehavior: Subscription;
  public currentEmployeeName: string = '';
  public routeHasAdminAccess: boolean = false;
  public isOpened: boolean = false;
  public countJobsRound: number = -1;
  public countJobs: number = -1;
  public displayDropdownCategory: boolean = false;

  private arrayRouteTranslate: Array<IRouterTranslate> = [
    { route: this.constantsService.BASE_PATH_JOB_VIEW, adminAccess: false },
    { route: this.constantsService.BASE_PATH_EMPLOYEE_EDIT, adminAccess: true },
    { route: `${path_module_admin.module}/${path_module_admin.employee_profile}`, adminAccess: true },
  ];

  constructor(
    public constantsService: ConstantsService,
    private changeDetectorRef: ChangeDetectorRef,
    public userService: UserService,
    public employerService: EmployerService,
    private jobService: JobService,
    private router: Router,
    private platformService: PlatformService
  ) {

    this.setCurrentUrl();

    this.subscriptionRouter = router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {

        this.currentTs = new Date().getTime();
        this.setCurrentUrl();
        this.changeDetectorRef.detach();
        this.changeDetectorRef.detectChanges();

        if (window.innerWidth < 992) {

          if (!document.getElementById("btn-navbar-toggler")?.classList.contains('collapse')) {
            setTimeout(() => {
              document.getElementById("btn-navbar-toggler").click()
            }, 200);
          }
        }
      }
    })
  }

  ngOnDestroy() {
    if (this, this.subscriptionRouter) { this.subscriptionRouter.unsubscribe(); }
    if (this, this.subscriptionLoginBehavior) { this.subscriptionLoginBehavior.unsubscribe(); }
  }

  ngOnInit(): void {
    this.subscriptionLoginBehavior = this.userService.loginBehavior.pipe(first()).subscribe(() => {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
    })
  }

  ngAfterContentInit(): void {

    if (!this.platformService.isPlatformBrowser)
      return;

    this.jobService.searchCategoryCount().toPromise().then(
      (res: any) => {

        if (res?.status_code !== status_code.success) {
          return;
        }

        const data = res['results'] || [];

        for (let index = 0; index < data.length; index++) {
          const element = data[index];

          this.POSITION_GROUPED.map(x => {
            x.items.filter(y => y.child === element.position).forEach(r => { r.count = element.count });
          })
        }

        let countTotal = 0;

        this.POSITION_GROUPED.forEach(parent => {

          let countParent = 0;

          parent.items.forEach(element => {

            if (element.count > 0)
              countParent += element.count
            else
              element.count = 0;

          });

          this.dummyFilterCount++;

          parent.count = countParent;
          countTotal += countParent;
        });

        if (+countTotal < 100) {
          this.countJobsRound = Math.trunc(countTotal / 10) * 10;
        }
        else {
          this.countJobsRound = Math.trunc(countTotal / 100) * 100;
        }

        this.countJobs = countTotal;
        this.changeDetectorRef.detach();
        this.changeDetectorRef.detectChanges();


      },
      err => {
        console.log(err)
      }

    );

    this.getStatusManager();
  }

  getStatusManager() {

    if (!(+this.userService.getIdCurrentUser() > 0) && this.userService.isEmployer()) {
      return;
    }
    if (!this.userService.isEmployer()) {
      return;
    }

    this.employerService.getStatusManager(+this.userService.getIdCurrentUser()).toPromise().then(
      res => {
        if (res.status_code === status_code.success) {

          if (+this.userService.getUserEventFlag > 0 && res.is_valid_session === 0) {
            this.userService.saveEvent(this.userService.getIdCurrentUser(), 'logout', 'force').toPromise().then();
            this.router.navigate([path_module_public.logout]);
            return;
          }

          if (res.user_role) {
            this.userService.setLocalUserRole(res.user_role)
          }

          return;
        }
      }, () => {
      }
    )

  }

  private setCurrentUrl(): void {

    var vcurrentUrl = this.router.url.substring(1).replace(/[0-9]/g, '').split('?')[0].split('#')[0];

    if (!vcurrentUrl) {
      this.currentUrl = '';
      return;
    }

    const ix = this.arrayRouteTranslate.findIndex(item => item.route.includes(vcurrentUrl));

    this.routeHasAdminAccess = false;

    if (ix !== -1) {
      const item = this.arrayRouteTranslate[ix];

      vcurrentUrl = item.route;

      if (item.adminAccess === true) {
        this.routeHasAdminAccess = true;
      }
    }

    this.currentUrl = vcurrentUrl;

    window.scrollTo(0, 0);
  }

  onClickCloseWindow(event: any) {
    window.close()
  }

  onClickCategory(event: MouseEvent) {

    this.displayDropdownCategory = false;
    this.changeDetectorRef.detectChanges();
  }

  onMouseCategoryEvent() {

    if (this.isTouchScreen) {
      return;
    }

    this.displayDropdownCategory = true;
    this.changeDetectorRef.detectChanges();
  }

  onClickToogleCategory(event: MouseEvent) {

    if (!this.isTouchScreen) {
      this.router.navigate(['/' + path_module_public.advice]);
      this.displayDropdownCategory = false;
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.displayDropdownCategory = !this.displayDropdownCategory;

    setTimeout(() => {
      this.changeDetectorRef.detectChanges();
    }, 10);
  }
}